import { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import {
  CREATE_ONLINE_BOOK,
  UPDATE_ONLINE_BOOK,
} from "../../../Schema/OnlineBook";

const useLessonForm = ({
  mutationDelete,
  editData,
  profileHook,
  handleClose,
  resetForm,
  setRefetch,
}) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createOnlineBook] = useMutation(CREATE_ONLINE_BOOK, {
    onCompleted: ({ createOnlineBook }) => {
      setLoading(false);

      if (createOnlineBook?.isSuccess === true) {
        setAlert(true, "success", createOnlineBook?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createOnlineBook?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateOnlineBook] = useMutation(UPDATE_ONLINE_BOOK, {
    onCompleted: ({ updateOnlineBook }) => {
      setLoading(false);
      if (updateOnlineBook?.isSuccess === true) {
        setAlert(true, "success", updateOnlineBook?.message);
        handleClose();
        resetForm();
        setRefetch();
        if (profileHook && editData?.image) {
          let splitSrc = editData?.image?.split(":")[4];
          mutationDelete.mutate({
            storage: "sr_music_academy",
            folder: "sr_music_images",
            file: splitSrc.split("/")[0],
          });
        }
      } else {
        setAlert(true, "error", updateOnlineBook?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  return { updateOnlineBook, createOnlineBook, loading, setLoading };
};

export default useLessonForm;
